import {AppThunkAction} from '../../../types/redux'

import {
  aFetchSellerTradePartners,
  selectSellerTradePartnersWhereLoaded,
} from '../../../data/seller-trade-partners'

export const selectSellerTradePartnerItemsArePending = (state: Record<string, any>): boolean =>
  !selectSellerTradePartnersWhereLoaded(state)

export const aInitializeSellerTradePartners =
  (): AppThunkAction<void> =>
  (dispatch): void => {
    dispatch(aFetchSellerTradePartners())
  }
